{
  "thirdparty": {
    "expedia": {
      "legalModal": {
        "title": "Booking additional travel services",
        "expandTitle": "View more information on insolvency protection",
        "poweredBy": "Powered by"
      },
      "nonSupportedLanguageWidget": {
        "collectAvios": "Collect Avios",
        "title": "Book a hotel in {cityName} and collect Avios",
        "description": "View our partner's hotel offers and collect Avios booking your stay in advance.",
        "ctaButton": "View hotel offers",
        "poweredBy": "Powered by"
      }
    }
  },
  "navigation": {
    "hotelsAndCarRental": "Hotels and mobility"
  },
  "labels": {
    "hotelsAndCarRental": "Hotels and mobility"
  },
  "fragments": {
    "expediaHotelsLegislationModal": {
      "localSettings": {},
      "url": "/en/3939006-3939006"
    },
    "expediaHotelsLegislationModalExpanded": {
      "localSettings": {},
      "url": "/en/3938984-3938984"
    },
    "expediaHotelsImage": {
      "localSettings": {},
      "url": "/en/3940212-3940212"
    }
  }
}
